import React, { useState, createContext, useEffect } from "react";

import * as SurveyRespondentData from "../utils/survey-respondent-data";
import { SURVEY_STATUS } from "../constants/survey_status";

export const SurveyRespondentDataContext = createContext();

const SurveyRespondentDataProvider = ({ data, children }) => {
  const surveyId = data.surveyId;
  const respondentIdType = data.identificationType;
  const isAnonymousSurvey = respondentIdType === null;
  const requiresPassword = data.requiresPassword ?? false;

  const [respondentId, setRespondentId] = useState("");
  const [surveyStatus, setSurveyStatus] = useState(SURVEY_STATUS.AWAITING_LOGIN);

  const submitNewRespondent = async (respondentId, password) => {
    const { response, error } = await SurveyRespondentData.validateRespondent(
      surveyId,
      respondentIdType,
      respondentId,
      password
    );

    switch (response) {
      case "accepted":
        setSurveyStatus(SURVEY_STATUS.PENDING);
        setRespondentId(respondentId);
        break;
      case "rejected":
      default:
        return error;
    }
  };

  useEffect(() => {
    SurveyRespondentData.updateStorage({
      respondentIdType,
      respondentId,
      isAnonymousSurvey,
      surveyId,
      surveyStatus,
    });
  }, [surveyStatus, respondentId]);

  return (
    <SurveyRespondentDataContext.Provider
      value={{
        surveyId,
        respondentId,
        setRespondentId,
        respondentIdType,
        requiresPassword,
        isAnonymousSurvey,
        surveyStatus,
        setSurveyStatus,
        submitNewRespondent,
      }}
    >
      {children}
    </SurveyRespondentDataContext.Provider>
  );
};

export default SurveyRespondentDataProvider;
